import { useLocation } from 'react-router-dom';

export const useSearchParam = key => {
    const location = useLocation();
    if (!location.search) return undefined;
    const searchParams = new URLSearchParams(location.search);
    return JSON.parse(searchParams.get(key));
};
